import { useQuery } from "@tanstack/react-query";

import { fetchDataGet } from "@/core/api/api-methods";
import { QUERY_KEYS } from "@/core/api/query-keys";
import type { ReportingService } from "@/features/reporting/api/endpoints";
import { reportingEndpoints } from "@/features/reporting/api/endpoints";
import type { ReportingSeriesParams } from "@/features/reporting/api/dto";
import { compactQuery, parseSeries } from "@/features/reporting/api/parse";

/** Série journalière (`GET .../Reporting/series`). */
export const useReportingSeries = (
  service: ReportingService,
  params: ReportingSeriesParams = {},
  enabled = true
) =>
  useQuery({
    queryKey: QUERY_KEYS.REPORTING_SERIES(service, params),
    queryFn: async () => {
      const raw = await fetchDataGet<unknown>({
        url: reportingEndpoints[service].series,
        queryParams: compactQuery({
          from: params.from,
          to: params.to,
          metricKey: params.metricKey,
          currency: params.currency,
        }),
      });
      return parseSeries(raw);
    },
    retry: (failureCount, error) =>
      !/401|403/.test(error?.message ?? "") && failureCount < 1,
    staleTime: 5 * 60 * 1000,
    enabled: enabled && Boolean(service),
  });
